// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PremiumPartnerRepoConfig from "./PremiumPartnerRepoConfig.bs.js";

var premiumPartnerReport = {
          "subscriptions": [
            {
                "subscription_price": 36,
                "payment_reference_number": "00000000-0000-0000-0000-000000000000",
                "scheme_name": "Weekly Pack",
                "start_date": "10/05/2021",
                "end_date": "17/05/2021",
                "status": "EXPIRED",
                "expiry_reason": "Time limit exceeded",
                "tentative_end_date": "17/05/2021"
            },
            {
                "subscription_price": null,
                "payment_reference_number": "00000000-0000-0000-0000-000000000000",
                "scheme_name": "Weekly Pack",
                "start_date": "10/05/2021",
                "end_date": "17/05/2021",
                "status": "ACTIVE",
                "expiry_reason": null,
                "tentative_end_date": "17/05/2021"
            },
            {
                "subscription_price": 58,
                "payment_reference_number": "00000000-0000-0000-0000-000000000000",
                "scheme_name": "Monthly Bonanza Pack",
                "start_date": "02/05/2021",
                "end_date": "09/06/2021",
                "status": "EXPIRED",
                "expiry_reason": "Time limit exceeded",
                "tentative_end_date": "01/06/2021"
            },
            {
                "subscription_price": 36,
                "payment_reference_number": "00000000-0000-0000-0000-000000000000",
                "scheme_name": "Weekly Pack",
                "start_date": "07/05/2021",
                "end_date": "14/05/2021",
                "status": "EXPIRED",
                "expiry_reason": "Time limit exceeded",
                "tentative_end_date": "14/05/2021"
            }
          ],
          "next_offset_ts": 1620394250
        };

var error_payload = {
        title: "test",
        message: "internal server error"
      };

function fetchSubscriptionReport(msisdn, offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: premiumPartnerReport
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PremiumPartnerRepoConfig.PpResponseConverter.execute, result);
                        });
            });
}

var PremiumPartner = {
  premiumPartnerReport: premiumPartnerReport,
  error_payload: error_payload,
  fetchSubscriptionReport: fetchSubscriptionReport
};

export {
  PremiumPartner ,
  
}
/* PremiumPartnerRepoConfig Not a pure module */
